import React from "react";

import {
  Box,
  Stack,
  Alert,
} from "@chakra-ui/react";

import useTranslations from "../../../../hooks/useTranslations";

import AnswerFrom from "./AnswerForm";

import { AnswerReviewProps } from "./types/AnswerReviewProps";

const AnswerEmpty: React.FC<AnswerReviewProps> = React.memo(
  ({ answer, path }) => {
    const t = useTranslations();

    return (
      // Account for the case where no answer has been given but a comment or a timeSpent value is recorded
      <Stack spacing="4" mb={answer?.value !== null && "4"}>
        <AnswerFrom {...{ answer, path }} />
        <Box maxWidth="2xl" w="full">
          <Alert status="warning" rounded="md">
            {t("reports.shared.noAnswer", { name: answer.user.name })}
          </Alert>
        </Box>
      </Stack>
    );
  }
);

export default AnswerEmpty;
